"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLast = void 0;
var react_1 = require("react");
function useLast(value) {
    var ref = react_1.useRef(value);
    react_1.useEffect(function () {
        ref.current = value;
    });
    return ref;
}
exports.useLast = useLast;
//# sourceMappingURL=use-last.js.map